module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a8118d3175b26ae9cb069df88a92e4a2.gif";